import type { I18nLocale } from "@/modules/i18n/types"

import { AVAILABLE_LOCALES } from "@/modules/i18n/constants"

export function getLocaleFromPathname(pathname: string): I18nLocale | undefined {
  const locale = pathname.split("/")[1] as I18nLocale

  return !AVAILABLE_LOCALES.includes(locale) ? undefined : locale
}
